
<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">
    
    <div v-if="items.some(el => el.email == '')">
      <Message severity="warn" :closable="true"> 
        Alcuni clienti non hanno indirizzo email 
      </Message>
    </div>

    <small>
      <div class="flex align-items-center text-sm">Fatture: {{selectedItems.length}} selezionate su {{items.length}}</div>
      <div class="flex align-items-center text-sm mb-2">Clienti: {{totalClients}}</div>
    </small>
    <DataTable :value="items" v-model:selection="selectedItems" :rowClass="rowClass" rowGroupMode="rowspan" :groupRowsBy="['ragsoc','email']" sortMode="multiple"  tableStyle="width: 100%" responsiveLayout="scroll">
      <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
      <Column field="ragsoc" header="Cliente" style="min-width: 200px">
          <template #body="{ data, field }">
              <div class="flex align-items-center gap-2">
                  <span>{{ data[field] }}</span>
              </div>
          </template>
      </Column>
      <Column field="email" header="Email" style="min-width: 200px">
        <template #body="{ data, field }">
          <span>{{ data[field] }}</span>
        </template>
        <!-- <template #editor="{ data, field }">
          <InputText v-model="data[field]" autofocus />
        </template> -->
      </Column>
      <Column field="numero" header="Fattura" style="min-width: 200px">
        <template #body="{ data, field }">
          <p v-if="data[field]"  @click="openFatturaPdf(data[field])" class="text-primary cursor-pointer">
            {{data[field]}}
          </p>
        </template>
      </Column>
      <Column field="data_emissione" header="Data Emissione" style="min-width: 150px">
        <template #body="{ data, field }">
          {{ data[field] ? moment(data[field]).format('YYYY-MM-DD') : '' }}
        </template>
      </Column>
      <Column field="mese_fatturazione" header="Mese Fatturazione" style="min-width: 150px">
        <template #body="{ data, field }">
          {{ data[field] || '' }}
        </template>
      </Column>
      <Column field="data_invio_cliente" header="Data Invio" style="min-width: 200px">
        <template #body="{ data, field }">
          {{ (data[field] !== null)? moment(data[field]).format('YYYY-MM-DD HH:mm'): '' }}
        </template>
      </Column>
    </DataTable>
  </div>

  <!-- Footer con bottoni - mostrato solo se hideFooter non è true -->
  <div v-if="!hideFooter" class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import { ref, getCurrentInstance, onMounted, computed, defineExpose} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import ServiceFatture from '@/services/ask-management/fatture-clienti-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    hideFooter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'invio-fatture-email'}
    const loader = ref(false)
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const serviceFatture = new ServiceFatture(self.$http, self.$eventBus)
    const items = ref(props.data)
    const selectedItems = ref([])

    
    onMounted(() => {
      selectedItems.value = items.value.filter(el => el.email != '');
    })
    
    const onOkButton = () => {
      return new Promise((resolve, reject) => {
        if (validateForm()) {

          loader.value = true
          service.sendFattureVenditaByEmail(selectedItems.value)
          .then((res) =>{
            toast.add({severity:'success', summary: 'Successo', detail:`${res.items} email inviate`, group: page.name});
            self.$eventBus.emit('email-sent', { success: true, items: res.items, data: selectedItems.value });
            resolve(res);
          })
          .catch((error) => {
            console.error('Errore nell\'invio email:', error)
            toast.add({severity:'error', summary: 'Errore', detail:'Errore nell\'invio delle email', group: page.name});
            self.$eventBus.emit('email-sent', { success: false, error: error.message });
            reject(error);
          })
          .finally(()=>{
            loader.value = false    
          })
        } else {
          reject(new Error('Validazione fallita'));
        }
      });
    }

    const onCancelButton = () => {
      if (props.hideFooter) {
        self.$eventBus.emit('email-sent', { success: false, error: 'Invio annullato' });
      } else {
        self.$eventBus.emit(`dialog-return-cancel-button`, {})
      }
    };

    const rowClass = (data) => {
      return [{ 'bg-pink-50': data.email == '' }];
    };

    const openFatturaPdf  = (numero) => {
      loader.value = true
      serviceFatture.openFatturaPdf(numero)
      .finally(() => {
        loader.value = false
      })
    }

    const totalClients = computed(() => {
      let clients = []
      for(let el of selectedItems.value) {
          clients.push(el.ragsoc)
      }
      const uniqueClients = [...new Set(clients)];
      return uniqueClients.length
    });

    const validateForm = () => {
      let valid = false
      if (selectedItems.value.length > 0) {
        valid = selectedItems.value.every(el => el.email != '')
        if (!valid) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Alcuni clienti non hanno indirizzo email', group: page.name});
        }
      }
      return valid
    }

    const result = {
      moment,
      page,
      items,
      selectedItems,
      loader,
      rowClass,
      totalClients,
      openFatturaPdf,
      onOkButton,
      onCancelButton,
    }

    defineExpose({
      onOkButton,
      onCancelButton,
      validateForm,
      selectedItems,
      items
    })

    return result
  }
}
</script>

